// extracted by mini-css-extract-plugin
module.exports = {"grouped-items-container":"VIP_GroupedItems__grouped-items-container","groupedItemsContainer":"VIP_GroupedItems__grouped-items-container"};